<template>
  <div class="bg-white rounded-full py-3 px-12 flex justify-center w-full">
    <slot />
  </div>
</template>
